import { call, cancel, select, takeLatest } from 'redux-saga/effects';
import {
  CheckoutProduktAfterLoadAzam,
  GlobalActions,
  GlobalPut,
  isAzam,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { getVersichertesRisikoString } from './inDashboardUebernehmenSaga';

export function* updateRisikoortAfterLoadAzamSaga() {
  yield takeLatest(GlobalActions.SAVED_STATES_LOADED, safeSaga(update, App.VWG_V2));
}

export function* update() {
  const state: IAppState = yield select();
  const globalPut = GlobalPut.getInstance();
  if (!isAzam(state.transientState.role)) {
    yield cancel();
  }
  if (state.transientState.isRisikoortVnAdresse) {
    const checkoutProduktAfterLoadAzam: CheckoutProduktAfterLoadAzam = {
      appId: App.VWG_V2,
      angebotsId: state.angebotsId,
      versichertesRisiko: `${state.risikoort.strasse} ${state.risikoort.hausnummer}, ${state.risikoort.plz} ${state.risikoort.ort}`,
    };
    yield call(
      [globalPut, globalPut.put],
      new GlobalActions().updateCheckoutAfterLoadAzam(checkoutProduktAfterLoadAzam),
    );

    yield call(
      [globalPut, globalPut.put],
      new GlobalActions().updateDashboardAfterLoadAzam({
        appId: App.VWG_V2,
        angebotsId: state.angebotsId,
        versichertesRisiko: getVersichertesRisikoString(
          state.risikoort,
          state.gebaeude.wohnflaeche,
        ),
        versicherterRisikoort: state.risikoort,
      }),
    );
  }
}
